// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-burger {
	position: fixed;
	top: 2rem;
	background-color: var(--neutral-color1);
	display: flex;
	flex-direction: column;
	z-index: 5002;
	animation: menu-slide-in-from-top-left 0.1s ease-in;
}

.nav-burger .closed {
	animation: menu-slide-out-to-top-left 0.1s ease-in;
}

.links a {
	color: var(--primary-color1);
	padding: 1rem;
	margin: 0rem 1rem;
	text-decoration: none;
	font-family: "Inter-Bold", sens-serif;
	font-weight: 700;
	font-size: 1.4rem;
	width: 100%;
	border-radius: 2rem;
	text-align: center;
}

.nav-burger .links {
	display: flex;
	animation: menu-slide-in-from-top-left 0.1s ease-in;
	padding: 0.2rem 0.2rem;
	color: var(--primary-color1);
	width: 90vw;
	z-index: 8003;
	margin-left: 5vw;
	background-color: var(--neutral-color1-0p8);
	border-radius: 2rem;
	box-shadow: 0px 0px 5px 1px;
	align-items: center;
}

.nav-burger .links .map {
	background: linear-gradient(
		90deg,
		rgba(242, 124, 42, 1) 0%,
		rgba(231, 84, 37, 1) 50%,
		rgba(231, 84, 37, 1) 100%
	);
	color: white;
}

.nav-burger .links .map.disabled {
	color: white;
	background: linear-gradient(
		90deg,
		hsl(0, 0%, 58%) 0%,
		rgb(100, 100, 100) 50%,
		rgb(90, 90, 90) 100%
	);
	pointer-events: none;
	cursor: default;
}

@keyframes menu-slide-in-from-top-right {
	0% {
		transform: translateX(100%) scale(0);
		opacity: 0;
	}
	100% {
		transform: translateX(0%) scale(1);
		opacity: 100;
	}
}

@keyframes menu-slide-in-from-top-left {
	0% {
		transform: translateX(-100%);
		opacity: 0;
	}
	100% {
		transform: translateX(0);
		opacity: 100;
	}
}

@keyframes menu-slide-out-to-top-left {
	100% {
		transform: translateX(-100%) scale(0);
		opacity: 0;
	}
	0% {
		transform: translateX(0) scale(1);
		opacity: 100;
	}
}

@keyframes appear {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 100;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/NavBar/MobileNav/BurgerMenu/BurgerMenu.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,SAAS;CACT,uCAAuC;CACvC,aAAa;CACb,sBAAsB;CACtB,aAAa;CACb,mDAAmD;AACpD;;AAEA;CACC,kDAAkD;AACnD;;AAEA;CACC,4BAA4B;CAC5B,aAAa;CACb,iBAAiB;CACjB,qBAAqB;CACrB,qCAAqC;CACrC,gBAAgB;CAChB,iBAAiB;CACjB,WAAW;CACX,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mDAAmD;CACnD,sBAAsB;CACtB,4BAA4B;CAC5B,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,2CAA2C;CAC3C,mBAAmB;CACnB,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC;;;;;EAKC;CACD,YAAY;AACb;;AAEA;CACC,YAAY;CACZ;;;;;EAKC;CACD,oBAAoB;CACpB,eAAe;AAChB;;AAEA;CACC;EACC,oCAAoC;EACpC,UAAU;CACX;CACA;EACC,kCAAkC;EAClC,YAAY;CACb;AACD;;AAEA;CACC;EACC,4BAA4B;EAC5B,UAAU;CACX;CACA;EACC,wBAAwB;EACxB,YAAY;CACb;AACD;;AAEA;CACC;EACC,qCAAqC;EACrC,UAAU;CACX;CACA;EACC,iCAAiC;EACjC,YAAY;CACb;AACD;;AAEA;CACC;EACC,UAAU;CACX;CACA;EACC,YAAY;CACb;AACD","sourcesContent":[".nav-burger {\n\tposition: fixed;\n\ttop: 2rem;\n\tbackground-color: var(--neutral-color1);\n\tdisplay: flex;\n\tflex-direction: column;\n\tz-index: 5002;\n\tanimation: menu-slide-in-from-top-left 0.1s ease-in;\n}\n\n.nav-burger .closed {\n\tanimation: menu-slide-out-to-top-left 0.1s ease-in;\n}\n\n.links a {\n\tcolor: var(--primary-color1);\n\tpadding: 1rem;\n\tmargin: 0rem 1rem;\n\ttext-decoration: none;\n\tfont-family: \"Inter-Bold\", sens-serif;\n\tfont-weight: 700;\n\tfont-size: 1.4rem;\n\twidth: 100%;\n\tborder-radius: 2rem;\n\ttext-align: center;\n}\n\n.nav-burger .links {\n\tdisplay: flex;\n\tanimation: menu-slide-in-from-top-left 0.1s ease-in;\n\tpadding: 0.2rem 0.2rem;\n\tcolor: var(--primary-color1);\n\twidth: 90vw;\n\tz-index: 8003;\n\tmargin-left: 5vw;\n\tbackground-color: var(--neutral-color1-0p8);\n\tborder-radius: 2rem;\n\tbox-shadow: 0px 0px 5px 1px;\n\talign-items: center;\n}\n\n.nav-burger .links .map {\n\tbackground: linear-gradient(\n\t\t90deg,\n\t\trgba(242, 124, 42, 1) 0%,\n\t\trgba(231, 84, 37, 1) 50%,\n\t\trgba(231, 84, 37, 1) 100%\n\t);\n\tcolor: white;\n}\n\n.nav-burger .links .map.disabled {\n\tcolor: white;\n\tbackground: linear-gradient(\n\t\t90deg,\n\t\thsl(0, 0%, 58%) 0%,\n\t\trgb(100, 100, 100) 50%,\n\t\trgb(90, 90, 90) 100%\n\t);\n\tpointer-events: none;\n\tcursor: default;\n}\n\n@keyframes menu-slide-in-from-top-right {\n\t0% {\n\t\ttransform: translateX(100%) scale(0);\n\t\topacity: 0;\n\t}\n\t100% {\n\t\ttransform: translateX(0%) scale(1);\n\t\topacity: 100;\n\t}\n}\n\n@keyframes menu-slide-in-from-top-left {\n\t0% {\n\t\ttransform: translateX(-100%);\n\t\topacity: 0;\n\t}\n\t100% {\n\t\ttransform: translateX(0);\n\t\topacity: 100;\n\t}\n}\n\n@keyframes menu-slide-out-to-top-left {\n\t100% {\n\t\ttransform: translateX(-100%) scale(0);\n\t\topacity: 0;\n\t}\n\t0% {\n\t\ttransform: translateX(0) scale(1);\n\t\topacity: 100;\n\t}\n}\n\n@keyframes appear {\n\t0% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 100;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
